/****************************************************************
 *   This code is generated by the Asamco Interface generator!  *
 *                                                              *
 * Do not forget to check the import statements.                *
 * Those might differ as generated for each interface           *
 * each project, and are relative to the location where         *
 * you save the typescript file                                 *
 ***************************************************************/
import { Validations, validate } from '@asamco/utils';
import { ModuleInfo } from './module-info.interface';

/** Interface for back-end LicenseInfo model. */
export interface LicenseInfo {
	// properties:
	/** No description found in back-end model. */
	customerCode?: string;
	/** No description found in back-end model. */
	productName?: string;
	/** No description found in back-end model. */
	modules?: ModuleInfo[];
	/** No description found in back-end model. */
	startDate?: Date;
	/** No description found in back-end model. */
	endDate?: Date;
	/** No description found in back-end model. */
	lastCheckDate?: Date;
	/** No description found in back-end model. */
	maxCheckDays?: number;
	/** No description found in back-end model. */
	maxUsers?: number;
	/** No description found in back-end model. */
	maxConcurrentUsers?: number;
	/** No description found in back-end model. */
	frontendVersion?: string;
	/** No description found in back-end model. */
	databaseVersion?: string;
	/** No description found in back-end model. */
	generalVersion?: string;
	/** No description found in back-end model. */
	locationCode?: string;
}

/** helper function that provides default values for LicenseInfo */
export function LicenseInfoDefaults(): LicenseInfo {
	return {
		customerCode: '',
		productName: '',
		modules: [],
		startDate: new Date(),
		endDate: new Date(),
		lastCheckDate: new Date(),
		maxCheckDays: 0,
		maxUsers: 0,
		maxConcurrentUsers: 0,
		frontendVersion: '',
		databaseVersion: '',
		generalVersion: '',
		locationCode: '',
	};
}

/** validations for LicenseInfo */
const LicenseInfoValidationRules: Validations = {};

/** helper function that checks if an object adheres to the validation rules of this model */
export function validateLicenseInfo(o: LicenseInfo) {
	return validate(<any>o, LicenseInfoValidationRules);
}
